import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import Step1_Add from "../Add_Fact/step1_add";
import { gql, useMutation, useQuery } from "@apollo/client";
import { error, warning } from "../../Controllers/toast";
import findPlantId from "../../Controllers/findPlantId";
import Loader from "../../Loader";
import { useDispatch, useSelector } from "react-redux";
import { add_fact_step1 } from "../../Redux/actions";

const GET_PLANT_INFO = gql`
  query Groups($plant_id: Int) {
    GetPlant(plant_id: $plant_id) {
      plant_id
      fact_timezone
      fact_power_unit
      fact_name
      fact_address
      fact_country
      fact_state
      fact_city
      fact_post_code
      fact_power_name
      fact_tel
      fact_index
      prod_index
    }
  }
`;
const CHANGE_PLANT = gql`
  mutation (
    $plant_id: Int!
    $fact_name: String!
    $fact_address: String!
    $fact_tel: String!
    $fact_city: String!
    $fact_state: String!
    $fact_country: String!
    $fact_timezone: String!
    $fact_power_unit: String!
    $fact_power_name: String!
    $fact_post_code: String!
    $fact_index: String!
    $prod_index: String!
  ) {
    ChangePlant(
      plantInput: {
        fact_name: $fact_name
        fact_address: $fact_address
        fact_tel: $fact_tel
        fact_city: $fact_city
        fact_state: $fact_state
        fact_country: $fact_country
        fact_timezone: $fact_timezone
        fact_power_unit: $fact_power_unit
        fact_power_name: $fact_power_name
        fact_post_code: $fact_post_code
        fact_index: $fact_index
        prod_index: $prod_index
      }
      plant_id: $plant_id
    ) {
      plant_id
      fact_name
      fact_index
      prod_index
    }
  }
`;

const EditFactPage = () => {
  const dispatch = useDispatch();
  const plant_id = findPlantId();
  const add_fact = useSelector((state) => state.add_fact_step1);
  const lang_choiced = useSelector((state) => state.lang_change);


  const { loading, refetch: refetchingPlantData } = useQuery(GET_PLANT_INFO, {
    variables: { plant_id: parseInt(plant_id) },
    onCompleted: ({ GetPlant }) => {
      //   console.log(GetPlant, "is GetPlant");
      dispatch(add_fact_step1(GetPlant));
    },
    onError: (err) => {
      error(lang_choiced.pages.edit_fact.getPlantInfoError);
    },
  });

  const [changePlantMutate, { error: changePlantError }] = useMutation(
    CHANGE_PLANT,
    {
      onCompleted: async (res) => {
        console.log(res);
        refetchingPlantData();

        warning(lang_choiced.pages.edit_fact.changePlantWarning);
      },
    }
  );

  if (!loading && add_fact.fact_name) {
    return (
      <div>
        <Card>
          <CardHeader>
            <h4>{lang_choiced.pages.edit_fact.title}</h4>
          </CardHeader>
          <CardBody>
            <Step1_Add
              page
              setData={(value) => {
                console.log(value, add_fact);
                const { prod_index, fact_index } = add_fact;
                changePlantMutate({
                  variables: {
                    plant_id: parseInt(plant_id),
                    ...value,
                    prod_index,
                    fact_index,
                  },
                });
              }}
            />
          </CardBody>
        </Card>
      </div>
    );
  } else {
    return (
      <div className="animated fadeIn ">
        <Loader />
      </div>
    );
  }
};

export default EditFactPage;
